import React from 'react'

const CanHelpMeItemComplement = ({ block }) => {
    return (
        block?.attributes?.complement && (
            <p className="baseocom-content-item-list">{block?.attributes?.complement}</p>
        )
    )
}

export default CanHelpMeItemComplement
